import { membersApi } from '../api/membersApi'

export const getMembers = async () => {
  try {
    const {
      data: { members },
    } = await membersApi.getMembers()
    return members
  } catch (error) {
    console.error(`Error fetching members: `, error)
    throw error
  }
}
